// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Welcome_wrapper__2yu9J","msgBox":"Welcome_msgBox__1hSr_"};